<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-9 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">Profil</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-body">
            <div class="row">
                <div class="col-4">
                    <button :class="class_gen" @click="generalClick()">
                        <i data-feather="user"></i> Général
                    </button>
                    <button :class="class_tel" @click="phoneClick()">
                        <i data-feather="phone"></i> Changer N° Téléphone
                    </button>
                    <button :class="class_lien" @click="genererLienClick()">
                        <i data-feather="link"></i> Generer un lien
                    </button>
                    <a href="/compte/suppression" class="btn btn-danger btn-block text-left mt-3 d-flex" style="color: white;">
                        <i data-feather="trash-2" style="margin-right: 5px;"></i> Supprimer mon compte
                    </a>
                </div>
                <div class="col-8">
                    <div v-if="step === 1">
                        <div class="card">
                            <div class="card-body">
                                <div class="form-row">
                                    <div class="col-md-6 col-12">
                                        <div class="form-group">
                                            <label>Nom</label>
                                            <input v-model="form.last_name" type="text" class="form-control" />
                                            <div v-if="errors.last_name" style="color: red">{{ errors.last_name[0] }}</div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-12">
                                        <div class="form-group">
                                            <label>Prénom(s)</label>
                                            <input v-model="form.first_name" type="text" class="form-control"/>
                                            <div v-if="errors.first_name" style="color: red">{{ errors.first_name[0] }}</div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-12">
                                        <div class="form-group">
                                            <label>Email</label>
                                            <input v-model="form.email" type="text" class="form-control" />
                                            <div v-if="errors.email" style="color: red">{{ errors.email[0] }}</div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-12">
                                        <div class="form-group">
                                            <label>Adresse</label>
                                            <input v-model="form.address" type="text" class="form-control" />
                                            <div v-if="errors.address" style="color: red">{{ errors.address[0] }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="form.profile != '1'" class="mt-1" style="opacity: 0.6">
                                    Personne à contacter en cas d’urgence
                                </div>
                                <div v-if="form.profile != '1'" class="form-row mt-1">
                                    <div class="col-md-6 col-12">
                                        <div class="form-group">
                                            <label>Nom & prénom(s)</label>
                                            <input v-model="form.contact_person_full_name" type="text" class="form-control" />
                                            <div v-if="errors.contact_person_full_name" style="color: red">{{ errors.contact_person_full_name[0] }}</div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-12">
                                        <div class="form-group">
                                            <label>Téléphone</label>
                                            <div class="input-group input-group-merge">
                                                <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M16.4999 12.6901V14.9401C16.5008 15.1489 16.458 15.3557 16.3743 15.5471C16.2907 15.7385 16.1679 15.9103 16.014 16.0515C15.8601 16.1927 15.6784 16.3002 15.4805 16.3671C15.2826 16.434 15.073 16.4589 14.8649 16.4401C12.5571 16.1893 10.3402 15.4007 8.39245 14.1376C6.58032 12.9861 5.04395 11.4497 3.89245 9.63757C2.62493 7.68098 1.83613 5.45332 1.58995 3.13507C1.57121 2.92767 1.59586 2.71864 1.66233 2.52129C1.72879 2.32394 1.83563 2.14259 1.97602 1.98879C2.11642 1.83499 2.2873 1.7121 2.47779 1.62796C2.66828 1.54382 2.87421 1.50027 3.08245 1.50007H5.33245C5.69643 1.49649 6.04929 1.62538 6.32527 1.86272C6.60125 2.10006 6.78151 2.42966 6.83245 2.79007C6.92742 3.51012 7.10354 4.21712 7.35745 4.89757C7.45836 5.16602 7.4802 5.45776 7.42038 5.73823C7.36056 6.01871 7.2216 6.27616 7.01995 6.48007L6.06745 7.43257C7.13512 9.31023 8.68979 10.8649 10.5675 11.9326L11.5199 10.9801C11.7239 10.7784 11.9813 10.6395 12.2618 10.5796C12.5423 10.5198 12.834 10.5417 13.1024 10.6426C13.7829 10.8965 14.4899 11.0726 15.21 11.1676C15.5743 11.219 15.907 11.4025 16.1448 11.6832C16.3827 11.9639 16.5091 12.3223 16.4999 12.6901Z" stroke="#4B4B4B" stroke-opacity="0.65" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>&nbsp; 228
                                                </span>
                                                </div>
                                                <input v-model="form.contact_person_number" class="form-control" type="number" />
                                            </div>
                                            <div v-if="errors.contact_person_number" style="color: red">{{ errors.contact_person_number[0] }}</div>
                                        </div>
                                    </div>
                                </div>
                                <button @click="updateGeneral()" v-if="!loading" class="btn btn-primary mt-1">Mettre à jour</button>
                                <button v-else class="btn btn-primary" type="button" disabled>
                                    <span class="align-middle">Loading...</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="step ===2">
                        <div class="card">
                            <div class="card-body">
                                <div class="form-row">
                                    <div class="col-md-12 col-12">
                                        <div class="form-group">
                                            <label>Téléphone</label>
                                            <div class="input-group input-group-merge">
                                                <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M16.4999 12.6901V14.9401C16.5008 15.1489 16.458 15.3557 16.3743 15.5471C16.2907 15.7385 16.1679 15.9103 16.014 16.0515C15.8601 16.1927 15.6784 16.3002 15.4805 16.3671C15.2826 16.434 15.073 16.4589 14.8649 16.4401C12.5571 16.1893 10.3402 15.4007 8.39245 14.1376C6.58032 12.9861 5.04395 11.4497 3.89245 9.63757C2.62493 7.68098 1.83613 5.45332 1.58995 3.13507C1.57121 2.92767 1.59586 2.71864 1.66233 2.52129C1.72879 2.32394 1.83563 2.14259 1.97602 1.98879C2.11642 1.83499 2.2873 1.7121 2.47779 1.62796C2.66828 1.54382 2.87421 1.50027 3.08245 1.50007H5.33245C5.69643 1.49649 6.04929 1.62538 6.32527 1.86272C6.60125 2.10006 6.78151 2.42966 6.83245 2.79007C6.92742 3.51012 7.10354 4.21712 7.35745 4.89757C7.45836 5.16602 7.4802 5.45776 7.42038 5.73823C7.36056 6.01871 7.2216 6.27616 7.01995 6.48007L6.06745 7.43257C7.13512 9.31023 8.68979 10.8649 10.5675 11.9326L11.5199 10.9801C11.7239 10.7784 11.9813 10.6395 12.2618 10.5796C12.5423 10.5198 12.834 10.5417 13.1024 10.6426C13.7829 10.8965 14.4899 11.0726 15.21 11.1676C15.5743 11.219 15.907 11.4025 16.1448 11.6832C16.3827 11.9639 16.5091 12.3223 16.4999 12.6901Z" stroke="#4B4B4B" stroke-opacity="0.65" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>&nbsp;
                                                    <input type="number" style="width:50px; border-width: 0; height: 20px" class="form-control" v-model="form.indic">
                                                </span>
                                                </div>
                                                <input v-model="form.phone" class="form-control" type="number" />
                                            </div>
                                            <div v-if="errors.phone" style="color: red">{{ errors.phone[0] }}</div>
                                        </div>
                                    </div>
                                    <button @click="updatePhone()" :disabled="loading" class="btn btn-primary mt-1">Mettre à jour</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="card">
                            <div class="card-body">
                                <div class="form-row">
                                    <div class="col-md-12 col-12">
                                        <div class="form-group">
                                            <label>Generer un lien</label>
                                            <div class="input-group input-group-merge" >
                                                <div class="input-group-prepend">
                                                    
                                                    <span class="input-group-text" readonly style="border-left-top-radius:5px;background:#efefef">
                                                        <!-- <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M16.4999 12.6901V14.9401C16.5008 15.1489 16.458 15.3557 16.3743 15.5471C16.2907 15.7385 16.1679 15.9103 16.014 16.0515C15.8601 16.1927 15.6784 16.3002 15.4805 16.3671C15.2826 16.434 15.073 16.4589 14.8649 16.4401C12.5571 16.1893 10.3402 15.4007 8.39245 14.1376C6.58032 12.9861 5.04395 11.4497 3.89245 9.63757C2.62493 7.68098 1.83613 5.45332 1.58995 3.13507C1.57121 2.92767 1.59586 2.71864 1.66233 2.52129C1.72879 2.32394 1.83563 2.14259 1.97602 1.98879C2.11642 1.83499 2.2873 1.7121 2.47779 1.62796C2.66828 1.54382 2.87421 1.50027 3.08245 1.50007H5.33245C5.69643 1.49649 6.04929 1.62538 6.32527 1.86272C6.60125 2.10006 6.78151 2.42966 6.83245 2.79007C6.92742 3.51012 7.10354 4.21712 7.35745 4.89757C7.45836 5.16602 7.4802 5.45776 7.42038 5.73823C7.36056 6.01871 7.2216 6.27616 7.01995 6.48007L6.06745 7.43257C7.13512 9.31023 8.68979 10.8649 10.5675 11.9326L11.5199 10.9801C11.7239 10.7784 11.9813 10.6395 12.2618 10.5796C12.5423 10.5198 12.834 10.5417 13.1024 10.6426C13.7829 10.8965 14.4899 11.0726 15.21 11.1676C15.5743 11.219 15.907 11.4025 16.1448 11.6832C16.3827 11.9639 16.5091 12.3223 16.4999 12.6901Z" stroke="#4B4B4B" stroke-opacity="0.65" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>&nbsp;
                                                        <i data-feather="phone" style="width:50px;height: 20px;"></i> -->
                                                        <!-- <input type="text" style="width:50px; border-width: 0; height: 20px" class="form-control" v-model="form.indic" >  -->
                                                    </span>
                                                     
                                                </div>
                                                <input v-model="form.uuid" class="form-control" type="text"   readonly/>
                                            </div>
                                            <div v-if="errors.uuid" style="color: red">{{ errors.uuid[0] }}</div>
                                        </div>
                                    </div>
                                    <button @click="updateGenererLien()" :disabled="loading" class="btn btn-primary mt-1">Generer</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade text-left" id="phoneUpdate" tabindex="-1" role="dialog" aria-labelledby="myModalLabel1" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="myModalLabel1">Saisir le code</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>
                            Veuillez entrer le code que vous avez reçu sur le N° de téléphone {{ form.phone }}
                        </p>
                        <div class="form-group">
                            <label>Code</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i data-feather="phone"></i></span>
                                </div>
                                <input v-model="form.code" class="form-control" type="number"/>
                            </div>
                            <div v-if="errors.code" style="color: red">{{ errors.code[0] }}</div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <button :disabled="loading" @click="verifyPhone()" type="button" class="btn btn-primary btn-block">Vérifier</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import {api} from "../../../helpers/shared";
    import {uuidGen} from "../../../helpers/shared"

    export default {
        name: "index",
        props:{
            user: {
                type: String,
                default: () => ''
            }
        },
        data: () => ({
            color: '#5E5873',
            class_gen: 'btn btn-warning btn-block text-left mb-1 d-flex',
            class_tel: 'n-neutre  d-flex mb-1 mt-1',
            class_lien:'n-neutre  d-flex mb-1',
            step: 1,
            form: {},
            loading: false,
            errors: []
        }),
        mounted() {
            this.form = { ...JSON.parse(this.user) };
            this.form.code = '';
            this.form.indic = '228';
            this.form.uuid = "";
            this.form.uuid2 = uuidGen()
        },
        methods:{
            phoneClick(){
                this.class_lien ='n-neutre d-flex';
                this.class_tel = 'btn btn-warning btn-block text-left mt-1 mb-1 d-flex';
                this.class_gen = 'n-neutre d-flex';
                this.errors = [];
                this.step = 2;
            },
            generalClick(){
                this.class_lien ='n-neutre d-flex';
                this.class_tel = 'n-neutre d-flex mb-1';
                this.class_gen = 'btn btn-warning btn-block text-left mb-1 d-flex';
                this.errors = [];
                this.step = 1;
            },
            genererLienClick(){
                this.class_lien =   'btn btn-warning btn-block text-left mt-1 d-flex';
                this.class_tel =    'n-neutre d-flex mt-1';
                this.class_gen =    'n-neutre d-flex';
                this.errors = [];
                this.step = 3;
            },

            updateGenererLien(){
                this.loading = true;
                axios.post(api('administration/users/profile-genererLien'),{uuid:this.form.uuid2}).then((response) => {
                    this.loading = false;
                    this.errors = [];
                    if (response.data.status){
                        this.$toasted.global.all()
                        this.getUriLinkValue()
                    }
                }).catch((error) => {
                    this.loading = false;
                    if (error.response.status === 401){
                    }else {
                        this.errors = error.response.data.errors
                    }
                })
            },
            getUriLinkValue(){
                axios.get(api('administration/users/uri_link')).then((response) => {
                    this.loading = false;
                    this.errors = [];
                    if(response.data.uri_link !== null && response.data.app_host !== null){
                        this.form.uuid =response.data.app_host+'/'+response.data.uri_link;
                    }else{
                        this.form.uuid ="";
                    }
                })
            },
            
            updateGeneral(){
                this.loading = true;
                axios.post(api('administration/users/profile'), this.form).then((response) => {
                    this.loading = false;
                    this.errors = [];
                    if (response.data.status){
                        this.$toasted.global.all()
                    }
                }).catch((error) => {
                    this.loading = false;
                    if (error.response.status === 401){
                    }else {
                        this.errors = error.response.data.errors
                    }
                })
            },
            updatePhone(){
                this.loading = true;
                axios.post(api('administration/users/profile-phone'), {phone:this.form.phone, indic: this.form.indic}).then((response) => {
                    this.loading = false;
                    this.errors = [];
                    if (response.data.status){
                        this.$document('#phoneUpdate').modal('show')
                    }
                }).catch((error) => {
                    this.loading = false;
                    if (error.response.status === 401){
                    }else {
                        this.errors = error.response.data.errors
                    }
                })
            },
            verifyPhone(){
                this.loading = true;
                axios.post(api('administration/users/profile-phone-verify'), {phone:this.form.phone, code: this.form.code}).then((response) => {
                    this.loading = false;
                    this.errors = [];
                    if (response.data.status){
                        this.$document('#phoneUpdate').modal('hide');
                        this.$toasted.global.all()
                    }
                }).catch((error) => {
                    this.loading = false;
                    if (error.response.status === 401){
                    }else {
                        this.errors = error.response.data.errors
                    }
                })
            }
        },
        created(){
            this.getUriLinkValue()
        }
    }
</script>

<style scoped>

</style>
